import React, {Component} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {ADD_RSS_INPUT_CHAR_LIMIT} from '../../../constants';

import ValidationIcons from '../../../reusable/ValidationIcons/ValidationIcons';

class AlertName extends Component {

    constructor(props) {
        super(props);

        this.changeAlertNameInput = this.changeAlertNameInput.bind(this);
        this.validateAlertNameInputField = this.validateAlertNameInputField.bind(this);
    }

    changeAlertNameInput(event) {
        this.props.resetAlertNameValidation();
        let inputValue = event.target.value;
        this.props.saveData({'name': inputValue});
    }

    validateAlertNameInputField(event) {
        //do not validate if the field is empty, but disable the continue button
        if (!this.props.data.name) {
            this.props.toggleContinueButtonDisabled(true);
            return;
        }
        this.props.validateAlertNameSection(this.props.data.name);
    }

    componentDidMount() {
        //if the page is in edit mode, a name exists, is valid, and the continue button is enabled
        let alertName = document.getElementsByClassName('alert-name-input')[0].value;
        if (alertName.length > 0) {
            this.props.toggleContinueButtonDisabled(false);
        }
    }

    render() {
        return (
            <div className="alert-name">

                <div className='alert-name__title-characters'>
                    <div>
                        <FormattedMessage id="Alerts_Create_UIText_name.step1.title"/>
                        <span className='required-field-star'></span>
                    </div>
                    <div className='alert-name__title-characters--remaining'>
                        <span>{ADD_RSS_INPUT_CHAR_LIMIT - this.props.data.name.length}</span> <FormattedMessage
                        id="Alerts_Create_UIText_name.step1.charactersRemaining"/>
                    </div>
                </div>

                <div className="input-container">
                    <input type="text"
                           autoFocus
                           maxLength={ADD_RSS_INPUT_CHAR_LIMIT}
                           className="alert-name-input"
                           onBlur={this.validateAlertNameInputField}
                           onChange={this.changeAlertNameInput}
                           value={this.props.data.name}
                           placeholder={this.props.intl.formatMessage(
                               {id: 'Alerts_Create_UIText_name.step1.uniqueTitleInfo'})}/>

                    <div className='validation-icons'>
                        {
                            this.props.alertNameValidationIconsState ?
                                <ValidationIcons renderState={this.props.alertNameValidationIconsState}/>
                                :
                                null
                        }
                    </div>

                </div>

                {
                    this.props.errorMessage ?
                        <div className="error-message"><FormattedMessage id={this.props.errorMessage}/></div>
                        :
                        null
                }

            </div>
        )
    }

}

export default injectIntl(AlertName);


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepOneComponents/CreateAlert.StepOne.AlertName.jsx